let cat_href = "https://yishitongyuanglobal.tmall.hk/?spm=a1z10.1-b-s.1997427721.d4918089.226aa3f3Ql9qKO";
let jd_href = "https://shop.m.jd.com/shop/introduce?shopId=12021154&venderId=12324263";
let city_href = "https://hcm.cgmgroup.jp";
let medical_href = "https://www.cgmmedical.jp";
let operation_href = "https://www.cgmgroup.jp";
let prescription_href = "https://www.cgmmedical.jp";
let prescription_search_href = "https://information.cgmgroup.jp";
let express_href = "https://www.p-express.jp";
let agreement_href = "https://www.cgmgroup.jp/huiyuanguiyue.html";
let protect_href = "https://www.cgmgroup.jp/gerenqingbao.html";
let site_href = "https://www.cgmgroup.jp/wangzhanshuoming.html";
let protocol_href = "https://www.cgmgroup.jp/wangzhanshuoming.html";
let protocol1_href = "https://www.cgmgroup.jp/gerenqingbao.html";
let pro_href = "https://www.cgmgroup.jp/gerenqingbao.html";
let pro1_href = "https://www.cgmgroup.jp/guiyue.html";
let pro2_href = "https://www.cgmgroup.jp/gerenqingbao.html";
export { cat_href, jd_href, city_href, medical_href, operation_href, prescription_href, prescription_search_href, express_href, agreement_href, protect_href, site_href, protocol_href, protocol1_href, pro_href,pro1_href,pro2_href }